import React, { useState } from "react";
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import Select from "react-select";
import cryptoOptions from "./CryptoCoins";
const AddWallet = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [selectedNetworks, setSelectedNetworks] = useState([]);
  const [resetKey, setResetKey] = React.useState(0);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const token = localStorage.getItem("admintoken");

  const handleAddWallet = async (e) => {
    e.preventDefault(); // Prevent page reload
    const walletData = {
      userId: id,
      asset: selectedAsset,
      network: selectedNetwork,
      wallet: walletAddress,
    };

    try {
      setLoading(true); // Show loader
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/wallet/add-wallet`,
        walletData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token if required
          },
        }
      );

      setLoading(false); // Hide loader
      if (res.data.success) {
        toast.success(res.data.message);
        navigate(`/dashboard/admin/user-details/${id}`);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred!");
    }
  };
  const formatOptionLabel = ({ label, flag }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={flag} alt="" style={{ width: 20, marginRight: 10 }} />
      <span>{label}</span>
    </div>
  );
  const handleCryptoChange = (option) => {
    setSelectedAsset(option.value);

    const selectedCoin = cryptoOptions.find(
      (coin) => coin.value === option.value
    );
    setSelectedNetworks(selectedCoin ? selectedCoin.networks : []);
    setSelectedNetwork("");
    setResetKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="add-bank-sec">
            <h1 className="text-center mb-5">Add New Wallet Address</h1>
            <div className="add-bank-sub">
              <form onSubmit={handleAddWallet}>
                <div className="mb-3">
                  <label>Asset</label>
                  <div className="mb-3">
                    <Select
                      options={cryptoOptions}
                      value={cryptoOptions.find(
                        (option) => option.value === selectedAsset
                      )}
                      onChange={handleCryptoChange}
                      formatOptionLabel={formatOptionLabel}
                      placeholder="Select Asset"
                      isSearchable
                    />
                  </div>

                  {selectedNetworks.length > 0 && (
                    <div className="mb-3">
                      <label>Network</label>
                      <Select
                        key={resetKey}
                        options={selectedNetworks.map((network) => ({
                          value: network,
                          label: network,
                        }))}
                        value={
                          selectedNetwork
                            ? { value: selectedNetwork, label: selectedNetwork }
                            : null
                        }
                        onChange={(network) =>
                          setSelectedNetwork(network.label)
                        }
                        placeholder="Select Network"
                        isSearchable
                      />
                    </div>
                  )}
                </div>
                <div className="add-bank-card w-100">
                  <label>Wallet Address</label>
                  <input
                    type="text"
                    className="wallet-address-input"
                    value={walletAddress}
                    onChange={(e) => setWalletAddress(e.target.value)}
                    placeholder="xxxxxxxxxxxxxxxxx"
                  />
                </div>
                <button className="btn   btn-primary" type="submit">
                  Add New Wallet Address
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddWallet;
